import React from 'react';

const AtendimentoIco = () => {
  return (
    <svg width="1.5rem" height="1.5rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 459.2 412.2">
      <path d="M72.8,330.4h91.3l44.2,70c6.8,11.4,21.6,15.2,33.1,8.4c3.4-2,6.3-4.9,8.4-8.4l44.2-70h92.4c40.1,0.1,72.7-32.4,72.8-72.5
	c0-0.1,0-0.2,0-0.3V72.8c0.1-40.1-32.4-72.7-72.5-72.8c-0.1,0-0.2,0-0.3,0H72.8C32.7-0.1,0.1,32.4,0,72.5c0,0.1,0,0.2,0,0.3v184.8
	C0.1,297.8,32.6,330.3,72.8,330.4L72.8,330.4z M90.7,76.7h276.1v33.6H90.7V76.7z M90.7,146.7h276.1v33.6H90.7V146.7z M90.7,216.7
	h155.7v33.6H90.7V216.7z"/>
    </svg>
  )
}

export default AtendimentoIco;